module.exports = __webpack_public_path__ + "img/product-fill.6fe82e18.svg";